import { render, staticRenderFns } from "./PlanningCard.vue?vue&type=template&id=a2f0c8fc"
import script from "./PlanningCard.vue?vue&type=script&lang=js"
export * from "./PlanningCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports